/**
 * Created by zhengyf 2017/8/28
 */

safeProblemCtrl.$inject = ['$scope', '$http', '$q', 'request'];
angular.module('safeProblemApp', ['app.core']);

angular
    .module('safeProblemApp')
    .controller('safeProblemCtrl', safeProblemCtrl);

function safeProblemCtrl($scope, $http, $q, request) {

    var vm = $scope;

    // ====================variable========================
    vm.d = {
        questionList: [
            {
                label: '请选择'
            },
            {
                label: '您祖母叫什么名字？'
            },
            {
                label: '您祖父叫什么名字？'
            },
            {
                label: '您的生日是什么时候？（例如：1980/01/01）'
            },
            {
                label: '您母亲的名字？'
            },
            {
                label: '您父亲的名字？'
            },
            {
                label: '您宠物的名字叫什么？'
            },
            {
                label: '您的车号是什么？'
            },
            {
                label: '您的家乡是哪里？'
            },
            {
                label: '您小学叫什么名字？'
            },
            {
                label: '您最喜欢的颜色？'
            }
        ],
        answerOne: null,
        answerTwo: null,
        answerThree: null
    };

    vm.f = {
        setSafeQuestion: setSafeQuestion,
        watchQuesOne: watchQuesOne,
        watchQuesTwo: watchQuesTwo,
        watchQuesThree: watchQuesThree
    };
    vm.d.questionList.forEach(function (item, index) {
        item.selected = false;
        item.id = index;
    });

    vm.quesOneList = angular.copy(vm.d.questionList);
    vm.quesTwoList = angular.copy(vm.d.questionList);
    vm.quesThreeList = angular.copy(vm.d.questionList);

    vm.quesOne = vm.quesOneList[0];
    vm.quesTwo = vm.quesTwoList[0];
    vm.quesThree = vm.quesThreeList[0];

    var alreadyChooseObj = {
        one: {
            index: null,
            value: null
        },
        two: {
            index: null,
            value: null
        },
        three: {
            index: null,
            value: null
        }
    };

    // ===================function=========================

    init();

    function init() {

    }

    function setSafeQuestion() {
        var url = '/usr/api/updatePerInfo';
        var data = [
            {
                question: vm.quesOne.label,
                answer: vm.d.answerOne
            },
            {
                question: vm.quesTwo.label,
                answer: vm.d.answerTwo
            },
            {
                question: vm.quesThree.label,
                answer: vm.d.answerThree
            }
        ];
        for(var i=0;i<data.length;i+=1) {
            if(!data[i].question || !data[i].answer || data[i].question === '请选择') {
                layer.alert('问题或答案不能为空');
                return;
            }
        }
        request.post(url, {}, {security: data}, true).then(success, error);

        function success(res) {
            layer.open({
                closeBtn: 0,
                title: '设置安全问题',
                content: '修改成功',
                btn: ['确定'],
                yes: function() {
                    window.location.href = '/account-center.html';
                }
            });
        }

        function error(err) {
            DSSX.dialog.err(err, {
                moduleName: '安全问题设置',
                funcName: 'setSafeQuestion',
                text: 'setSafeQuestion fail'
            });
        }
    }

    function watchQuesOne() {
        console.log('question one onchange... : ');
        var questionTwoList = vm.quesTwoList;
        var questionThreeList = vm.quesThreeList;
        if (alreadyChooseObj.one.value && (alreadyChooseObj.one.value !== vm.quesOne)) {
            questionTwoList.splice(alreadyChooseObj.one.index, 0, alreadyChooseObj.one.value);
            questionThreeList.splice(alreadyChooseObj.one.index, 0, alreadyChooseObj.one.value);
            sort4(questionTwoList);
            sort4(questionThreeList);
        }
        alreadyChooseObj.one.value = angular.copy(vm.quesOne);
        for (var i = 0, len = questionTwoList.length; i < len; i += 1) {
            if (vm.quesOne.id === questionTwoList[i].id) {
                questionTwoList.splice(i, 1);
                break;
            }
        }
        for (var i = 0, len = questionThreeList.length; i < len; i += 1) {
            if (vm.quesOne.id === questionThreeList[i].id) {
                questionThreeList.splice(i, 1);
                break;
            }
        }

    }

    function watchQuesTwo() {
        console.log('question two onchange... : ');
        var questionOneList = vm.quesOneList;
        var questionThreeList = vm.quesThreeList;
        if (alreadyChooseObj.two.value && (alreadyChooseObj.two.value !== vm.quesTwo)) {
            questionOneList.splice(alreadyChooseObj.two.index, 0, alreadyChooseObj.two.value);
            questionThreeList.splice(alreadyChooseObj.two.index, 0, alreadyChooseObj.two.value);
            sort4(questionOneList);
            sort4(questionThreeList);

        }
        alreadyChooseObj.two.value = angular.copy(vm.quesTwo);
        for (var i = 0, len = questionOneList.length; i < len; i += 1) {
            if (vm.quesTwo.id === questionOneList[i].id) {
                questionOneList.splice(i, 1);
                break;
            }
        }
        for (var i = 0, len = questionThreeList.length; i < len; i += 1) {
            if (vm.quesTwo.id === questionThreeList[i].id) {
                questionThreeList.splice(i, 1);
                break;
            }
        }
    }

    function watchQuesThree() {
        console.log('question two onchange... : ');

        var questionOneList = vm.quesOneList;
        var questionTwoList = vm.quesTwoList;
        if (alreadyChooseObj.three.value && (alreadyChooseObj.three.value !== vm.quesThree)) {
            questionOneList.splice(alreadyChooseObj.three.index, 0, alreadyChooseObj.three.value);
            questionTwoList.splice(alreadyChooseObj.three.index, 0, alreadyChooseObj.three.value);
            sort4(questionOneList);
            sort4(questionTwoList);
        }
        alreadyChooseObj.three.value = angular.copy(vm.quesThree);
        for (var i = 0, len = questionOneList.length; i < len; i += 1) {
            if (vm.quesThree.id === questionOneList[i].id) {
                questionOneList.splice(i, 1);
                break;
            }
        }
        for (var i = 0, len = questionTwoList.length; i < len; i += 1) {
            if (vm.quesThree.id === questionTwoList[i].id) {
                questionTwoList.splice(i, 1);
                break;
            }
        }
    }

    function sort4(array) {
        var len = array.length,
            i, j, tmp;
        for (i = 0; i < len; i++) {
            for (j = len - 1; j > i; j--) {
                if (+array[j].id < +array[j - 1].id) {
                    tmp = array[j - 1];
                    array[j - 1] = array[j];
                    array[j] = tmp;
                }
            }
        }
    }

}
